

import Carousel, { CarouselResponsiveOptions } from 'primevue/carousel';
import { ref } from 'vue';

export default {
	name: 'CarouselGame2',
	components: {
		Carousel,
	},
	setup() {
		const products = ref([
			{
				image: 'https://snc168.sgp1.digitaloceanspaces.com/theme/prod-8.webp',
				name: 'name',
				href: '/slot',
			},
			{
				image: 'https://snc168.sgp1.digitaloceanspaces.com/theme/prod-9.webp',
				name: 'name',
				href: '/slot',
			},
			{
				image: 'https://snc168.sgp1.digitaloceanspaces.com/theme/prod-10.webp',
				name: 'name',
				href: '/slot',
			},
			{
				image: 'https://snc168.sgp1.digitaloceanspaces.com/theme/prod-11.webp',
				name: 'name',
				href: '/slot',
			},
			{
				image: 'https://snc168.sgp1.digitaloceanspaces.com/theme/prod-12.webp',
				name: 'name',
				href: '/slot',
			},
			{
				image: 'https://snc168.sgp1.digitaloceanspaces.com/theme/prod-13.webp',
				name: 'name',
				href: '/slot',
			},
			{
				image: 'https://snc168.sgp1.digitaloceanspaces.com/theme/prod-14.webp',
				name: 'name',
				href: '/slot',
			},
		]);

		const responsiveOptions = ref<CarouselResponsiveOptions[]>([
			{
				breakpoint: '1400px',
				numVisible: 5,
				numScroll: 1
			},
			{
				breakpoint: '1199px',
				numVisible: 4,
				numScroll: 1
			},
			{
				breakpoint: '767px',
				numVisible: 2,
				numScroll: 1
			},
			{
				breakpoint: '575px',
				numVisible: 1,
				numScroll: 1
			}
		]);


		return {
			products,
			responsiveOptions,
		}
	}
}
